import * as React from 'react';
import { RefObject, useCallback, useMemo, useRef, useState } from 'react';

export function useRefComponent<Props>(
  Comp: React.ForwardRefExoticComponent<any>
): [v: RefObject<Props>, e: () => JSX.Element] {
  const ref = useRef<Props>(null);
  const [comp] = useState(<Comp ref={ref} />);
  const element = useCallback(() => comp, [comp]);
  return [ref, element];
}

export function useRefCompNoProps<T extends React.ForwardRefExoticComponent<any>>(
  Comp: T
): [v: RefObject<React.ComponentRef<T>>, e: () => JSX.Element] {
  const ref = useRef<React.ComponentRef<T>>(null);

  const comp = useMemo(() => React.createElement(Comp, { ref }), []);
  const element = useCallback(() => comp, [comp]);
  return [ref, element];
}
